module.exports = __webpack_public_path__ + "static/media/full-screen-enter.85175ea7.svg";